import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SubscriptionModel } from '../../../../shared/models/subscription.model';

@Component({
    selector: 'account-subscriptions-list-item',
    templateUrl: './account.subscriptions.list.item.component.html',
    styleUrls: ['./../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsListItemComponent {
    @Input('subscription') subscription: SubscriptionModel;

    /** Format date string to work in Safari */
    public sanitizeDate(datetime: string) {
        return datetime.replace(/\s/g, 'T');
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/account/subscriptions/list/item/account.subscriptions.list.item.component.ts